// extracted by mini-css-extract-plugin
export default {"radioBtn":"participant-card_radioBtn__03cEW"};